import Application from './application';

export default class FavoriteAdapter extends Application {
  async addToFavorite(payload) {
    const url = `${this.host}/favorites`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...this.headers,
      },
      body: JSON.stringify({ data: payload }),
    });
    return await res.json();
  }

  async removeFromFavorite(payload) {
    const url = `${this.host}/favorites`;
    await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...this.headers,
      },
      body: JSON.stringify({ data: payload }),
    });
    return;
  }
}
